import Modal from '@/components/common/modals/Modal';
import { Paragraph } from '@/components/common/Typography';
import ModalManager, { useModal } from '@/components/ModalManager';
import { useTrackModalShown } from '@/services/analytics/useTracking';

export interface WhatIsAnIRAModalProps {}

export const showWhatIsAnIRAModal = (props: WhatIsAnIRAModalProps) =>
    ModalManager.show(WhatIsAnIRAModal, props);

const WhatIsAnIRAModal = ModalManager.create<WhatIsAnIRAModalProps>(() => {
    useTrackModalShown('What Is An IRA');

    const modal = useModal();

    return (
        <Modal
            title="What is an IRA?"
            isOpen={modal.visible}
            onClose={modal.hide}
        >
            <Paragraph>
                An IRA (individual retirement account) is a tax advantaged
                account to encourage investing towards retirement. There are
                contribution limits each year and you may be eligible to deduct
                contributions or distributions, depending on the type of IRA you
                set up, your current income, and whether or not your employer
                provides a 401k. Click each type to learn more.
            </Paragraph>
        </Modal>
    );
});

export default WhatIsAnIRAModal;
